// React
import React from "react";
import { Route, Switch } from "react-router-dom";

// Router
import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

// Default Pages
import NotFound from "./pages/NotFound";

// Pages
import Contacts from "./pages/Contacts";
import List from "./pages/List";
import Lists from "./pages/Lists";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Team from "./pages/Team";

export default function Routes({ appProps }) {
  return (
    <Switch>
      <AuthenticatedRoute path="/contacts" exact component={Contacts} appProps={appProps} />
      <AuthenticatedRoute path="/person/:personid" exact component={Contacts} appProps={appProps} />
      <AuthenticatedRoute path="/" exact component={Lists} appProps={appProps} />
      <AuthenticatedRoute path="/lists" exact component={Lists} appProps={appProps} />
      <AuthenticatedRoute path="/list/:listid" exact component={List} appProps={appProps} />
      <AuthenticatedRoute path="/team" exact component={Team} appProps={appProps} />
      <UnauthenticatedRoute path="/login" exact component={Login} appProps={appProps} />
      <UnauthenticatedRoute path="/signup" exact component={Signup} appProps={appProps} />
      { /* Finally, catch all unmatched routes */ }
      <Route component={NotFound} />
    </Switch>
  );
}
